import { createAction, props } from '@ngrx/store';
import {
  IApproveUploadedDocsParams,
  IApproveDocumentsResponse,
  IRejectDocumentRequest,
  IRejectDocumentsResponse,
  IApproveDocsRequest,
  IRejectDocsRequest
} from '../models/approve-document.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const approveDocumentRequest = createAction('[ApproveDocuments] Load ApproveDocuments', props<{ request: IApproveDocsRequest }>());

export const approveDocumentResponse = createAction(
  '[ApproveDocuments] Load ApproveDocuments Success',
  props<{ response: IApproveDocumentsResponse }>()
);

export const approveDocumentFailure = createAction(
  '[ApproveDocuments] Load ApproveDocuments Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//REJECT document
export const rejectDocumentRequest = createAction('[RejectDocuments] Load reject Documents', props<{ request: IRejectDocsRequest }>());

export const rejectDocumentResponse = createAction(
  '[RejectDocuments] Load reject Documents Success',
  props<{ response: IRejectDocumentsResponse }>()
);

export const rejectDocumentFailure = createAction(
  '[RejectDocuments] Load reject Documents Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
